export default "__VITE_ASSET__DUwi$crv__"